define(['c21', 'jquery'], function (c21, $) {
   "use strict";

   var RewriteEngine = function () {
         var m_oRules = [];

         this.addRule = function (xPattern, aRules, oAdditionalParams) {
            m_oRules.push({
               pattern: new RegExp(xPattern),
               rules: aRules,
               additionalParams: oAdditionalParams
            });
         };

         this.match = function (sUrl) {
            var oParams = {};
            $.each(m_oRules, function (index, rule) {
               var aMatch = sUrl.match(rule.pattern);
               if (aMatch) {
                  $.each(rule.rules, function (index, matchRule) {
                     if (matchRule) {
                        oParams[matchRule] = aMatch[index];
                     }
                  });
                  $.each(rule.additionalParams, function (key, value) {
                     oParams[key] = value;
                  });
               }
            });
            return oParams;
         };
      },

      rewriteEngine = new RewriteEngine();

   rewriteEngine.addRule("^/mls-address-search/$", [null], { t: 0 });
   rewriteEngine.addRule("^/agent-name-search/$", [null], { t: 2 });
   rewriteEngine.addRule("^/office-name-search/$", [null], { t: 1 });
   rewriteEngine.addRule("^/location-name-search/$", [null], {});
   rewriteEngine.addRule("^/(esp/)?real-estate/[^/]*/L([^/]*)/?$", [null, null, "lid"], { t: 0 });
   rewriteEngine.addRule("^/(esp/)?search/?$", [null, null], { t: 0 });
   rewriteEngine.addRule("^/real-estate/[^/]*/A([^/]*)/?$", [null, "ag"], { t: 0 });
   rewriteEngine.addRule("^/real-estate/[^/]*/O([^/]*)/?$", [null, "of"], { t: 0 });
   rewriteEngine.addRule("^/real-estate/[^/]*/T([^/]*)/?$", [null, "te"], { t: 0 });
   rewriteEngine.addRule("^/real-estate-agents/[^/]*/L([^/]*)/?$", [null, "lid"], { t: 2 });
   rewriteEngine.addRule("^/real-estate-agents/[^/]*/O([^/]*)/?$", [null, "of"], { t: 2 });
   rewriteEngine.addRule("^/real-estate-offices/[^/]*/L([^/]*)/?$", [null, "lid"], { t: 1 });
   rewriteEngine.addRule("^/[^/]*/real-estate/[^.]*/([0-9]+)-L([^/]*)/?$", [null, null, "lid"], { t: 0 });
   rewriteEngine.addRule("^/schools/[^/]*/[^/]*/O([A-Z0-9]*)-L([A-Z0-9]*)$", [null, "inst_id", "lid"], {});

   rewriteEngine.addRule("^/real-estate-sale/[^/]*/L([^/]*)/?$", [null, "lid"], { t: 0 });
   rewriteEngine.addRule("^/real-estate-lease/[^/]*/L([^/]*)/?$", [null, "lid"], { t: 0 });
   rewriteEngine.addRule("^/real-estate-sale/[^/]*/[^/]*/L([^/]*)/?$", [null, "lid"], { t: 0 });
   rewriteEngine.addRule("^/real-estate-lease/[^/]*/[^/]*/L([^/]*)/?$", [null, "lid"], { t: 0 });
   rewriteEngine.addRule("^/[^/]*/real-estate-sale/[^.]*/([0-9]+)-L([^/]*)/?$", [null, null, "lid"], { t: 0 });
   rewriteEngine.addRule("^/[^/]*/real-estate-lease/[^.]*/([0-9]+)-L([^/]*)/?$", [null, null, "lid"], { t: 0 });
   rewriteEngine.addRule("^/real-estate/[^/]*/[^/]*/L([^/]*)/?$", [null, "lid"], { t: 0 });
   
   return rewriteEngine;
});
